import * as Chess from "chess.js";
import { BehaviorSubject } from "rxjs";

const chess = new Chess();

export const gameSubject = new BehaviorSubject();

export function initGame() {
  const savedGame = localStorage.getItem("savedGame");
  if (savedGame) {
    chess.load(savedGame);
  }
  updateGame();
}

export function resetGame() {
  chess.reset();
  updateGame();
}

export function move(from, to, promotion) {
  let tempMove = { from, to };
  if (promotion) {
    tempMove.promotion = promotion;
  }
  const legalMove = chess.move(tempMove);

  if (legalMove) {
    updateGame();
  }
}

export function handleMove(from, to) {
  const promotions = chess.moves({ verbose: true }).filter((m) => m.promotion);
  if (promotions.some((p) => `${p.from}:${p.to}` === `${from}:${to}`)) {
    const pendingPromotion = {
      from,
      to,
      color: promotions[0].color,
    };
    updateGame(pendingPromotion);
  }
  const { pendingPromotion } = gameSubject.getValue();
  if (!pendingPromotion) {
    move(from, to);
  }
}

function updateGame(pendingPromotion) {
  const isGameOver = chess.game_over();

  const newGame = {
    board: chess.board(),
    turn: chess.turn(),
    pendingPromotion,
    isGameOver,
    result: isGameOver ? getGameResult : null,
  };

  localStorage.setItem("savedGame", chess.fen());

  gameSubject.next(newGame);
}

function getGameResult() {
  if (chess.in_checkmate()) {
    const winner = chess.turn() === "w" ? "BLACK" : "WHITE";
    return `CHECKMATE - WINNER ${winner}`;
  } else if (chess.in_draw()) {
    let reason = "50 MOVES RULE";
    if (chess.in_stalemate()) {
      reason = "STALEMATE";
    } else if (chess.in_threefold_repetition()) {
      reason = "REPETITION";
    } else if (chess.insufficient_material()) {
      reason = "INSUFFICIENT MATERIAL";
    }
    return `DRAW - REASON ${reason}`;
  } else {
    return "UNKNOWN REASON";
  }
}
